import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Seo } from '../components/Seo';

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-black text-white antialiased">
    <Seo
      title="Personvern | Refuel Weekend"
      description="Les korleis Refuel Weekend behandlar personopplysningar når du brukar nettsida, medlemskontoen, nyheitsbrevet og kontaktskjemaet."
      path="/p-policy"
    />
    <Navbar />
    <main className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-20">
      <Link to="/" className="text-sm text-white/55 hover:text-white transition-colors">Til framsida</Link>
      <article className="mt-8 space-y-8">
        <header>
          <p className="text-[#ff2e2e] text-sm font-bold uppercase tracking-widest">Refuel Weekend</p>
          <h1 className="text-4xl md:text-5xl font-bold mt-2" style={{ fontFamily: "'Oktah Round', sans-serif" }}>Personvernerklæring</h1>
          <p className="text-white/45 text-sm mt-3">Sist oppdatert: 29. oktober 2026</p>
        </header>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">Kven behandlar opplysningane?</h2>
          <p className="text-white/70 leading-relaxed">Refuel Weekend behandlar personopplysningar når du brukar nettsida eller deltek på arrangementet. Spørsmål om personvern kan sendast til <a className="text-[#ff2e2e] hover:underline" href="mailto:info@refuel.rest">info@refuel.rest</a>.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">Kva opplysningar samlar vi inn?</h2>
          <ul className="list-disc pl-6 space-y-2 text-white/70 leading-relaxed">
            <li>Kontoinformasjon som namn, e-postadresse, telefonnummer og medlemsnummer.</li>
            <li>Innloggingsopplysningar. Passord blir lagra som ein kryptografisk hash, ikkje som lesbar tekst. Ved Google- eller annan ekstern innlogging får vi opplysningane leverandøren deler med oss.</li>
            <li>Innhald du sjølv sender inn, som spørsmål, anmeldingar, nyheitsbrevregistreringar, favorittar, bilete og bilettekstar.</li>
            <li>Tekniske opplysningar som er nødvendige for innlogging, tryggleik og drift av tenesta.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">Kvifor brukar vi opplysningane?</h2>
          <p className="text-white/70 leading-relaxed">Vi brukar opplysningane for å opprette og drifte medlemskontoar, administrere arrangementet, svare på førespurnader, sende nyheitsbrev til dei som har meldt seg på, vise innsendt innhald og førebyggje misbruk. Vi behandlar berre opplysningar som er relevante for desse føremåla.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">Deling med andre</h2>
          <p className="text-white/70 leading-relaxed">Vi sel ikkje personopplysningar. Opplysningar kan behandlast av leverandørar som hjelper oss med drift, lagring, e-post og innlogging. Når du vel Google, Discord, Spotify, GitHub eller X for innlogging, blir du òg omfatta av personvernvilkåra til den valde leverandøren. Vi ber ikkje om passordet ditt hos desse tenestene.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">Lagring og sletting</h2>
          <p className="text-white/70 leading-relaxed">Vi lagrar opplysningar så lenge det er nødvendig for føremåla over. Du kan be om innsyn, retting eller sletting av opplysningar knytte til kontoen din. Vi kan måtte ta vare på enkelte opplysningar når lova krev det. Nyheitsbrev kan du melde deg av via lenka i e-posten.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">Informasjonskapslar og lokal lagring</h2>
          <p className="text-white/70 leading-relaxed">Nettsida brukar nødvendig nettlesarlagring for innlogging og funksjonar du ber om. Innhald frå eksterne tenester, som kart eller musikkspelarar, kan bruke eigne informasjonskapslar etter vilkåra til tenesta.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">Dine rettar</h2>
          <p className="text-white/70 leading-relaxed">Du kan be om innsyn i, retting av eller sletting av personopplysningane dine, og protestere mot behandling der regelverket gir rett til det. Ta kontakt på <a className="text-[#ff2e2e] hover:underline" href="mailto:info@refuel.rest">info@refuel.rest</a>. Er du mindreårig, be gjerne ein føresett om hjelp.</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-bold">Endringar</h2>
          <p className="text-white/70 leading-relaxed">Vi kan oppdatere denne erklæringa dersom nettsida eller behandlinga av opplysningar endrar seg. Den nyaste versjonen blir publisert på denne sida.</p>
        </section>
      </article>
    </main>
    <Footer />
  </div>
);

export default PrivacyPolicy;